export default function(size, arrayGeneral) {
  let subarray = []; // массив в который будет выведен результат.
  for (let i = 0; i < Math.ceil(arrayGeneral.length / size); i++){
    subarray[i] = arrayGeneral.slice((i * size), (i * size) + size);
  }
  return [...subarray]
}